module.exports = __webpack_public_path__ + "media/images/landing_page/liaa_inkubatora_atbalsts-bb7539a806b0bfd325270db9c1f8dd58.png";